export default __webpack_public_path__ + "static/media/icon--fee05.9534bf14.svg";